var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramAwards40(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Features-and-Benefits",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Awards40"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(7.800000, 7.100000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy",
    transform: "translate(14.200000, 0.900000)",
    stroke: "#706D6E"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 2.03074866,
    y1: 0.432352941,
    x2: 2.03074866,
    y2: 3.89117647,
    id: "Path-32"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.65534759,
    y1: 2.16176471,
    x2: 0.406149733,
    y2: 2.16176471,
    id: "Path-32-Copy"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(3.200000, 7.900000)",
    stroke: "#4F4C4D",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path-5",
    points: "0 16.11675 4.87047232 16.11675 10.9514419 0 6.1243776 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-6",
    fill: "#FFCC00",
    points: "10.9514419 0.23017753 18.9139115 16.11675 13.6013197 16.11675 8.84848521 6.05153979"
  }))), /*#__PURE__*/React.createElement("line", {
    x1: 3.05,
    y1: 15.4,
    x2: 0.65,
    y2: 15.4,
    id: "Path-32-Copy",
    stroke: "#706D6E"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1.7,
    y1: 14.2,
    x2: 1.7,
    y2: 16.6,
    id: "Path-32",
    stroke: "#706D6E"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22.05,
    y1: 12.4,
    x2: 19.65,
    y2: 12.4,
    id: "Path-32-Copy-2",
    stroke: "#706D6E"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20.7,
    y1: 11.2,
    x2: 20.7,
    y2: 13.6,
    id: "Path-32-Copy-3",
    stroke: "#706D6E"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramAwards40);
export default __webpack_public_path__ + "static/media/pictogramAwards40.34e392a14a41aefd7a301faab96abd04.svg";
export { ForwardRef as ReactComponent };